import { HomeworkReview } from "@/components/homework/HomeworkReview";
import { Skeleton } from "@/components/shared/Skeleton";
import { SharedHomeworkDocument } from "@/generated/graphql";
import { useQuery } from "@apollo/client/react";

/**
 * One assignment opened from the link a student shared. No sign-in: the teacher receiving it may
 * have no account here, so the id in the URL is the only thing standing between this page and
 * anyone else. Read-only, and it carries everything the teacher's own pages show — a teacher
 * marking a class works from this link alone.
 */
export function SharedHomeworkPage({ homeworkId }: { homeworkId: string }) {
  const { data, loading, error } = useQuery(SharedHomeworkDocument, {
    variables: { homeworkId },
  });

  const homework = data?.sharedHomework ?? null;

  return (
    <div className="min-h-screen bg-app-sky text-app-text">
      <div className="mx-auto max-w-6xl space-y-5 px-4 py-6 sm:px-6 sm:py-8">
        {loading && !homework ? (
          <div className="app-card space-y-3 p-4 sm:p-6">
            <Skeleton className="h-7 w-52" />
            <Skeleton className="h-40" />
          </div>
        ) : error || !homework ? (
          <div className="app-card space-y-2 p-4 sm:p-6">
            <h1 className="app-title">This homework link doesn't work</h1>
            <p className="body-sm text-app-muted">
              It may have been mistyped, or the assignment has since been removed.
            </p>
          </div>
        ) : (
          <>
            <p className="caption uppercase tracking-widest text-app-muted">Shared homework</p>
            <HomeworkReview homework={homework} />
          </>
        )}
      </div>
    </div>
  );
}
